




























import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import CardTitle from "../CardTitle.vue";
import { bus } from "../../main";
import { DocAttestatoFinale } from "../../_models/docAttestatoFinale";
import * as user from "../../_store/user.module";
import AttestatoFinale from "../AttestatoFinale.vue";

@Component({
  components: {
    CardTitle,
    AttestatoFinale
  }
})
export default class AttestatoTirEstivi extends Vue {
  @Prop() info!: any;
  @Prop() dialogParams!: any;
  @Prop() activityType!: string;

  private dialog: boolean;
  private step1: boolean;

  constructor() {
    super();
    this.dialog = false;
    this.step1 = true;
  }

  continua(){
    this.step1 = false;
  }

  close() {
    this.dialog = false;
    bus.$emit("destroyAttestatoFinaleDialog");
  }

  created(){
    bus.$on("closeAttestatoFinaleDialog", () =>{
      this.close()
    })
  }
}
